// extracted by mini-css-extract-plugin
export var authorAvatarContainer = "bf_dm";
export var authorInfoContainer = "bf_dn";
export var authorInfoDetails = "bf_dp";
export var authorInfoSection = "bf_dq";
export var authorSocialLinks = "bf_ds";
export var authorTooltipContainer = "bf_dt";
export var authorTooltipContent = "bf_dl";
export var authorTooltipLink = "bf_dr";
export var authorTooltipZIndex = "bf_dv";